var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullSignal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 112.344,
    height: 87.759,
    viewBox: "0 0 112.344 87.759",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18618",
    "data-name": "Rectangle 18618",
    width: 112.344,
    height: 87.759,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23576",
    "data-name": "Group 23576",
    transform: "translate(-899.656 -193.656)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23571",
    "data-name": "Group 23571",
    transform: "translate(899.656 193.656)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23566",
    "data-name": "Group 23566",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49990",
    "data-name": "Path 49990",
    d: "M0,25.882c.7-2.725,2.8-4.38,4.744-6.123A73.706,73.706,0,0,1,41.294,1.445C65.6-2.963,87.364,2.7,106.329,18.668c1.368,1.152,2.68,2.379,3.941,3.647a6.193,6.193,0,0,1,1.624,6.934,6.154,6.154,0,0,1-5.627,4.2,6.762,6.762,0,0,1-5.23-2.065c-2.083-1.888-4.148-3.814-6.379-5.518a61.6,61.6,0,0,0-31.106-12.5,63,63,0,0,0-42.214,9.881,65.852,65.852,0,0,0-10.052,8.108c-2.4,2.32-5.259,2.758-7.917,1.311a6.222,6.222,0,0,1-2.977-3.5c-.106-.3-.26-.579-.392-.867V25.882",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49991",
    "data-name": "Path 49991",
    d: "M95.178,75.025A54.561,54.561,0,0,1,133.09,90.959a6.339,6.339,0,0,1,1.981,6.468,6.429,6.429,0,0,1-10.2,3.475c-1.783-1.454-3.458-3.043-5.281-4.443a39.947,39.947,0,0,0-21.04-8.229A41.708,41.708,0,0,0,66.14,98.665c-1.474,1.286-2.747,2.842-4.771,3.386a6.518,6.518,0,0,1-7.11-2.642,6.289,6.289,0,0,1,.293-7.469,42.438,42.438,0,0,1,9.007-7.63c9.29-6.178,19.552-9.194,31.619-9.286",
    transform: "translate(-38.075 -53.722)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49992",
    "data-name": "Path 49992",
    d: "M131.921,150.141a34.07,34.07,0,0,1,24.312,9.866,6.442,6.442,0,0,1,.287,9.084,6.319,6.319,0,0,1-8.887.477c-2.531-2.2-5.127-4.238-8.365-5.278a20.922,20.922,0,0,0-21.1,4.163,13.33,13.33,0,0,1-3.2,2.235,6.274,6.274,0,0,1-7.678-2.5,6.433,6.433,0,0,1,.964-8.135,33.379,33.379,0,0,1,22.008-9.8c.657-.037,1.313-.085,1.654-.107",
    transform: "translate(-76.095 -107.509)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49993",
    "data-name": "Path 49993",
    d: "M181.041,242.37a11.018,11.018,0,1,1-10.981-11.049,11,11,0,0,1,10.981,11.049",
    transform: "translate(-113.856 -165.639)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullSignal);
export default __webpack_public_path__ + "static/media/full-signal.467de6cd396219e552da2256ca2a52d7.svg";
export { ForwardRef as ReactComponent };